import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { SubSectionSharedModule } from "pf_styleguide";

import { BlogService } from "../shared/blog.service";
import { LoadingModule } from "../shared/module/loading/loading.module";
import { NotFoundModule } from "../shared/module/not-found/not-found.module";
import { PaginationModule } from "../shared/module/pagination/pagination.module";
import { MomentTimezonePipeModule } from "../shared/module/pipe/moment-timezone-pipe.module";
import { SafeHtmlPipeModule } from "../shared/module/pipe/safe-html-pipe.module";
import { BlogComponent } from "./blog.component";
import { CardComponent } from "./card/card.component";
import { BlogCategoryComponent } from "./category/blog-category.component";
import { BlogHomepageComponent } from "./homepage/blog-homepage.component";
import { BlogPostComponent } from "./post/blog-post.component";
import { BlogPostBodyComponent } from "./post/body/blog-post-body.component";
import { BlogTagsComponent } from "./tags/blog-tags.component";
import { LinkService } from "../shared/link.service";

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: "",
                component: BlogComponent,
                children: [
                    {
                        path: "",
                        component: BlogHomepageComponent,
                    },
                    {
                        path: ":slug",
                        component: BlogPostComponent,
                    },
                    {
                        path: "category/:category",
                        component: BlogCategoryComponent,
                    },
                ],
            },
        ]),
        LoadingModule,
        NotFoundModule,
        PaginationModule,
        MomentTimezonePipeModule,
        SafeHtmlPipeModule,
        NgbDropdownModule,
        SubSectionSharedModule,
    ],
    declarations: [
        BlogCategoryComponent,
        BlogComponent,
        BlogHomepageComponent,
        BlogPostComponent,
        BlogPostBodyComponent,
        BlogTagsComponent,
        CardComponent,
    ],
    providers: [BlogService, LinkService],
})
export class BlogModule {}
